import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue";
var _hoisted_1 = { key: 0 };
var _hoisted_2 = {
    key: 0,
    class: "flex items-center mb-5 mx-7 xs:mx-10"
};
var _hoisted_3 = { class: "ml-2 xs:ml-0 font-medium" };
var _hoisted_4 = { class: "flex flex-col px-7 xs:pl-2.5 xs:pr-5 gap-y-2.5 xs:gap-y-0" };
import NotificationItem from '@common/components/Notifications/components/NotificationItem.vue';
import ECircleMark from '@common/ui/ECircleMark/ECircleMark.vue';
import { isMobile } from '@common/utils/Crossbrowser';
export default /*#__PURE__*/ _defineComponent({
    __name: 'NotificationsList',
    props: {
        title: { default: '' },
        notifications: {}
    },
    setup: function (__props) {
        return function (_ctx, _cache) {
            var _a;
            return (_ctx.notifications && ((_a = _ctx.notifications) === null || _a === void 0 ? void 0 : _a.length) > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    (_ctx.title)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            (_unref(isMobile)())
                                ? (_openBlock(), _createBlock(ECircleMark, {
                                    key: 0,
                                    theme: "gray"
                                }))
                                : _createCommentVNode("", true),
                            _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.title), 1)
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_4, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifications, function (notification) {
                            return (_openBlock(), _createBlock(NotificationItem, {
                                key: notification.id,
                                notification: notification,
                                variant: "detailed"
                            }, null, 8, ["notification"]));
                        }), 128))
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
